(() => {
  const selector = 'section[id$="__product_categories"] .hdt-collections-list';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const enablePointerDrag = (track) => {
    if (track.dataset.pointerDragReady === 'true') return;
    track.dataset.pointerDragReady = 'true';

    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let suppressClick = false;

    const finishDrag = () => {
      if (pointerId === null) return;

      const activePointerId = pointerId;
      pointerId = null;

      if (track.hasPointerCapture(activePointerId)) {
        track.releasePointerCapture(activePointerId);
      }

      track.classList.remove('is-pointer-dragging');

      if (moved) {
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      }
    };

    track.addEventListener('pointerdown', (event) => {
      if (!mobileQuery.matches || event.pointerType === 'touch' || event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      moved = false;
      track.setPointerCapture(pointerId);
      track.classList.add('is-pointer-dragging');
    });

    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;

      const distance = event.clientX - startX;
      if (!moved && Math.abs(distance) < 5) return;

      moved = true;
      track.scrollLeft = startScrollLeft - distance;
      event.preventDefault();
    });

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', finishDrag);
    track.addEventListener('dragstart', (event) => {
      if (mobileQuery.matches) event.preventDefault();
    });
    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  };

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach(enablePointerDrag);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
